export const PRIMARY = 'PRIMARY'
export const SECONDARY = 'SECONDARY'
